export class SharedConstants {

  static APP_NAME = 'Formbird';
  static SYSTEM_TYPE_DOCUMENT = 'document';
  static SYSTEM_TYPE_VERSION = 'version';
  static SYSTEM_TYPE_TEMPLATE = 'template';
  static SYSTEM_TYPE_ACCOUNT = 'account';
  static SYSTEM_TYPE_LOGIN = "login";
  static SYSTEM_TYPE_RULESET_DOCUMENT = 'rulesetdocument';
  static SYSTEM_TYPE_SYSTEM_ACTION = 'systemaction';
  static SYSTEM_TYPE_SCHEDULE = 'schedule';
  static SYSTEM_TYPE_FILE_REFERENCE = 'fileReference';
  static SYSTEM_TYPE_CONFIGURATION = 'configuration';
  static SYSTEM_TYPE_COMPONENT = 'component';
  static SYSTEM_TYPE_COUNTER = 'counter';
  static SYSTEM_TYPE_PASSWORD_RESET = 'passwordReset';
  static SYSTEM_TYPE_ACCOUNT_SECURITY = 'accountSecurity';
  static SYSTEM_TYPE_ACCOUNT_CONTROL = 'accountControl';
  static SYSTEM_TYPE_ACCOUNT_GROUP_CONFIG = 'accountGroupConfig';
  static SYSTEM_TYPE_PASSWORD = 'password';
  static SYSTEM_TYPE_RULESET = 'ruleset';
  static SYSTEM_TYPE_RULESET_INCLUDE = 'rulesetInclude';
  static SYSTEM_TYPE_APPLICATION = 'application';
  static SYSTEM_TYPE_VENDOR_LIBRARY = 'vendorLibrary';
  static SYSTEM_TYPE_URL_ROUTE = 'urlRoute';
  static SYSTEM_TYPE_OFFLINE_INDEX = 'offlineIndex';

  static STATUS_PENDING = 'pending';
  static STATUS_PROCESSING = 'processing';
  static STATUS_PROCESSED = 'processed';
  static STATUS_ERROR = 'error';
  static STATUS_SUCCESS = 'success';
  static STATUS_WARNING = 'warning';
  static STATUS_INFO = 'info';
  static STATUS_FORBIDDEN = 'forbidden';

  static METHOD_POST = 'POST';
  static METHOD_GET = 'GET';
  static METHOD_DELETE = 'DELETE';
  static METHOD_PUT = 'PUT';

  static DEFAULT_PAGE = 0;
  static DEFAULT_PAGE_SIZE = 50;
  static DEFAULT_TOTAL_ITEM = 10000;
  static DEFAULT_SEARCH_DELAY = 500;
  static DEFAULT_MAX_SEARCH_QUERY_LENGTH = 2048;

  static DEFAULT_SEARCH_SELECT_PAGE_SIZE = 5;
  static DEFAULT_SEARCH_SELECT_PAGE = 0;

  // field types
  static FIELD_TYPE_RELATED = 'Related';
  static FIELD_TYPE_HTML = 'html';
  static FIELD_TYPE_CUSTOM = 'Custom';

  static ELASTIC_DOCUMENT_TYPE = 'documents';
  static ELASTIC_DOCUMENT_PREFIXES = {
    'mongodb': '_source'
  };

  static DEFAULT_DB_PROVIDER = 'mongodb';
  static DEFAULT_DB_CONNECTION = 'default';

  static RULESET_EVENT_NAME = 'EventName';

  static RULESET_RELATIONSHIPS = {
    PRERENDER_EVENT_NAME: {
      name: 'PreRender',
      relName: 'preRenderClientRuleRel'
    },
    ONLOAD_EVENT_NAME: {
      name: 'OnLoad',
      relName: 'onLoadClientRuleRel'
    },
    ON_RECEIVE_EVENT_NAME: {
      name: "OnReceive",
      relName: "onReceiveClientRuleRel"
    },
    ON_FIELD_CHANGE_EVENT_NAME: {
      name: 'OnFieldChange',
      relName: 'onFieldChangeClientRuleRel'
    },
    PRESAVE_EVENT_NAME: {
      name: 'PreSave',
      relName: 'preSaveClientRuleRel'
    },
    PRESAVE_OFFLINE_EVENT_NAME: {
      name: "PreSaveOffline",
      relName: "preSaveOfflineClientRuleRel"
    },
    POSTSAVE_CLIENT_EVENT_NAME: {
      name: 'PostSaveClient',
      relName: 'postSaveClientRuleRel'
    },
    PRESAVE_SERVER_EVENT_NAME: {
      name: 'PreSaveServer',
      relName: 'preSaveServerRuleRel'
    },
    POSTSAVE_EVENT_NAME: {
      name: 'PostSave',
      relName: 'postSaveServerRuleRel'
    },
    POSTLOGIN_CLIENT_EVENT_NAME: {
      name: 'PostLoginClient',
      relName: 'postLoginClientRuleRel'
    },
    PRELOGOUT_CLIENT_EVENT_NAME: {
      name: 'PreLogoutClient',
      relName: 'preLogoutClientRuleRel'
    },
    PRELOGIN_SERVER_EVENT_NAME: {
      name: 'PreLoginServerName',
      relName: 'preLoginServerRuleRel'
    },
    POSTLOGIN_SERVER_EVENT_NAME: {
      name: 'PostLoginServerName',
      relName: 'postLoginServerRuleRel'
    },
    PRELOGOUT_SERVER_EVENT_NAME: {
      name: 'PreLogoutServerName',
      relName: 'preLogoutServerRuleRel'
    },
    POSTLOGOUT_SERVER_EVENT_NAME: {
      name: 'PostLogoutServerName',
      relName: 'postLogoutServerRuleRel'
    },
    PREDELETE_CLIENT_EVENT_NAME: {
      name: 'PreDeleteClient',
      relName: 'preDeleteClientRuleRel'
    }
  };

  static ONLOAD_DONE_RULES_EVENT_NAME = 'OnLoadDone';

  static ON_CHANGE_FILTER_EVENT_NAME = 'OnChangeFilter';

  static LOCATION_CHANGE_STATE_EVENT = '$locationChangeStart';
  static UPDATE_SHOW_VALUE_EVENT = 'updateShowValue';

  static EVENT_LIST_NAME = 'eventList';
  static EVENT_VALIDATION_VALUES_NAME = 'validationValues';
  static EVENT_REFRESH_COMPONENT_NAME = 'refreshComponentData';

  static INSERT_OPERATION_TYPE = 'Insert';
  static UPDATE_OPERATION_TYPE = 'Update';

  static CSV_DOC_ID_MATCH_MERGE = 'merge';
  static CSV_DOC_ID_MATCH_REPLACE = 'replace';
  static CSV_DOC_ID_NO_MATCH_ADD = 'add';
  static CSV_DOC_ID_NO_MATCH_ERR = 'error';

// operation types for clicking on navigation bar
  static SAVE_CLICK_OPERATION_TYPE = 'SaveClick';
  static NEW_CLICK_OPERATION_TYPE = 'NewClick';
  static PRINT_CLICK_OPERATION_TYPE = 'PrintClick';
  static MAP_CLICK_OPERATION_TYPE = 'MapClick';

// operation types, for checking access
  static OPERATION_TYPE_READ = 'Read';
  static OPERATION_TYPE_CREATE = 'Create';
  static OPERATION_TYPE_UPDATE = 'Update';
  static OPERATION_TYPE_DELETE = 'Delete';
  static OPERATION_TYPE_EXECUTE = 'Execute';
  static OPERATION_TYPE_OFFLINE = 'Offline';

// error types, for server functions
  static ERROR_TYPE_NOACCESS = 'No Access';
  static ERROR_TYPE_NOTFOUND = 'Not Found';
  static ERROR_TYPE_INTERNAL = 'Internal';
  static ERROR_TYPE_GONE = 'Gone';

// websocket messages
  static WEB_SOCKET_MESSAGE_TEMPLATE_DRAFT_SAVED = 'template_draft_saved';
  static WEB_SOCKET_MESSAGE_UPDATE_PREVIEW = 'update_preview';
  static WEB_SOCKET_MESSAGE_SAVE_DOCUMENT = 'save_document';
  static WEB_SOCKET_MESSAGE_PASSWORD_RESET = 'password_reset';
  static WEB_SOCKET_MESSAGE_SIGN_OUT_ALL_DEVICE = 'sign_out_all_device';

  static DIALOG_OK_OPTION = 'OK';
  static DIALOG_CANCEL_OPTION = 'CANCEL';

  static RULESET_AFFECTED_DOCUMENT_ID = 'affectedDocId';
  static RULESET_AFFECTED_TEMPLATE_ID = 'affectedTplId';
  static RULESET_AFFECTED_FIELD_NAME = 'affectedFieldName';
  static RULESET_NEW_FILTER = 'newFilter';
  static RULESET_RESULT_FLAG = 'flag';
  static RULESET_PARENT_DOCUMENT = 'parentDoc';
  static RULESET_CHILD_DOCUMENT = 'childDoc';

  static checkListSeparator = '^';

  static DEFAULT_MESSAGE_LENGTH = 200;

  static DEFAULT_EXPIRY_DURATION_MINUTES = 60;

  static MAKE_CURRENT_VERSION_KEY = 'makeCurrentVersion';
  static IMPORT_PREVIOUS_VERSION = "importPreviousVersion";

  static SEARCH_PROVIDERS = {
    ELASTIC: 'elastic',
    MONGODB: 'mongodb'
  };
  static DOCUMENT_FIELD_NAME_UPLOAD_FILE = 'imageFileNo96'; // key used at systemHeader to refer to the uploaded file
  static PASSWORD_RESET = "password:reset"

  static DEFAULT_MAX_UPLOAD_SIZE = 50;  //size in megabytes

  static SYSTEM_TYPE_QUERY = "query";
}
